(function () {
    'use strict';

    angular.module("imApp").factory("orderLinePsService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1098,
                    parameters: parms || {}
                });
            },
            listSelectProducts: function (parms) {
                return $ihttp.post({
                    method: 1099,
                    parameters: parms || {}
                });
            },
            listSelectedProducts: function (parms) {
                return $ihttp.post({
                    method: 1100,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
